import { useSearchParams } from "react-router-dom";
import { SearchVacancies, VacanciesList, HotVacancies } from "../../widget";
import { removeNullKeys } from "../../shared/lib/helpers";
import { searchVacancy } from "./lib/searchParamsVacancy";
import type { FormVacancy } from "../../widget/SearchVacancies";
import { Button } from "../../shared/ui";
import { getRouteDirection } from "../../shared/constants/routes";
import { SearchParamsVacancyEnum, DEFAULT_VACANCIES_TO_SHOW } from "../../shared/constants/searchParams";
import { useGetVacancyListQuery } from "../../entities/Vacancy";
import { classNames } from "../../shared/lib/classNames";
import styles from "./VacanciesPage.module.scss";

import { useMemo } from "react";

export const VacanciesPage = () => {
    const [searchParams, setSearchParams] = useSearchParams(
        new URLSearchParams({ [SearchParamsVacancyEnum.TAKE]: DEFAULT_VACANCIES_TO_SHOW }),
    );

    const { data: vacancyList, isLoading } = useGetVacancyListQuery(searchVacancy(searchParams));

    const handleUpdateSearchParams = (data: FormVacancy) => {
        setSearchParams(
            removeNullKeys({
                ...data,
                [SearchParamsVacancyEnum.TAKE]: DEFAULT_VACANCIES_TO_SHOW,
            }),
            { preventScrollReset: true },
        );
    };

    const countVacancies = useMemo(() => {
        if (!vacancyList || vacancyList?.length === 0) return 0;
        return vacancyList?.reduce((acc, direction) => (acc += direction.count), 0);
    }, [vacancyList]);

    return (
        <>
            <SearchVacancies countVacancies={countVacancies || 0} onSetParams={handleUpdateSearchParams} />
            <HotVacancies />
            <VacanciesList
                isLoading={isLoading}
                vacancyList={vacancyList}
                renderButton={({ id, className }) => (
                    <Button
                        as="link"
                        className={classNames({
                            cls: styles.button,
                            additional: [className],
                        })}
                        to={`${getRouteDirection()}?${SearchParamsVacancyEnum.DIRECTION}=${id}`}
                    >
                        Все вакансии направления
                    </Button>
                )}
            />
        </>
    );
};
